import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';

import { overlayBunja } from '@flipster/overlay';
import { css } from '@flipster/styled-system/css';
import { OverlayModal } from '@flipster/ui';

import { accountValidationBunja } from '../shared/account-validation/state';
import {
  WalletModalOptions,
  WalletModalOptionsContext,
  WalletModalTypeContext,
  walletModalBunja,
} from '../shared/core/state';
import { SelectAssetContent } from '../shared/select-asset/content';
import { Header as SelectAssetHeader } from '../shared/select-asset/header';
import { Content } from './content';
import { Header as ConvertHeader } from './header';

interface ConvertModalProps {
  options: WalletModalOptions;
}
const ConvertModal = ({ options = { defaultValues: {} } }: ConvertModalProps) => {
  return (
    <WalletModalTypeContext value='convert'>
      <WalletModalOptionsContext value={options}>
        <ConvertModalImpl />
      </WalletModalOptionsContext>
    </WalletModalTypeContext>
  );
};

const ConvertModalImpl = () => {
  const { selectedCurrencyAtom } = useBunja(walletModalBunja);
  const [selectedCurrency, setSelectedCurrency] = useAtom(selectedCurrencyAtom);
  return (
    <OverlayModal
      size='small'
      className={css(selectedCurrency == null && { h: 640 })}
      header={selectedCurrency == null ? <SelectAssetHeader /> : <ConvertHeader />}
      withFooter={selectedCurrency != null}
    >
      {selectedCurrency == null && <SelectAssetContent onClickCurrency={setSelectedCurrency} />}
      {selectedCurrency != null && <Content />}
    </OverlayModal>
  );
};

export const openConvertModalBunja = bunja(() => {
  const overlay = bunja.use(overlayBunja);
  const { checkUserBlockAndOpenAlertIfNeeded } = bunja.use(accountValidationBunja);
  async function openConvertModal(options: WalletModalOptions = { defaultValues: {} }) {
    // skip checkKycAndOpenAlertIfNeeded for conversion
    if (!(await checkUserBlockAndOpenAlertIfNeeded('convert'))) return;
    overlay.open(() => <ConvertModal options={options} />);
  }
  return { openConvertModal };
});
openConvertModalBunja.debugLabel = 'openConvertModalBunja';

export const useConvertModal = () => {
  const { openConvertModal } = useBunja(openConvertModalBunja);
  return openConvertModal;
};
